<template>
    <div class="setUserRate">
        <el-dialog :visible="isShowRate" width="70%" @close="handleClose">
            <el-card class="box-card" shadow="hover">
                <div slot="header" class="clearfix">
                    <span
                        style="font-weight:700;font-size:13px"
                    >"{{publickData.brandName}}终端类型"的结算成本</span>
                </div>
                <el-form ref="form" :inline="true">
                    <el-tabs v-model="baseOrRise">
                        <el-tab-pane label="基础费率" name="base">
                            <el-tabs v-model="baseActiveName">
                                <!-- Tab页 -->
                                <el-tab-pane
                                    v-for="(tabItem,tabIndex) in baseTabContent"
                                    :label="tabItem.title"
                                    :name="String(tabItem.settle_type)"
                                    :key="tabIndex"
                                >
                                    <template v-for="(titleItem,titleIndex) in tabItem.list">
                                        <!-- 小标题 -->
                                        <div :key="titleIndex">
                                            <div class="type_title">{{titleItem.title}}</div>
                                            <el-form-item
                                                v-for="(item,index) in titleItem.list"
                                                :label="item.title"
                                                :key="index"
                                            >
                                                <el-input
                                                    v-model="item.value"
                                                    size="medium"
                                                    :placeholder="isEdit == 1 ? item.sub_title : ''"
                                                    :disabled="level != 0 && canSet == false"
                                                ></el-input>
                                            </el-form-item>
                                            <el-divider></el-divider>
                                        </div>
                                    </template>
                                    <el-button
                                        :loading="btnLoading"
                                        @click="handleSubmit(tabItem.list,tabItem.settle_type,1)"
                                        type="primary"
                                        style="font-size:12px"
                                        :disabled="isEdit != 1"
                                        v-if="level == 0 || (isEdit == 1 && canSet == true)"
                                    >提 交</el-button>
                                </el-tab-pane>
                            </el-tabs>
                        </el-tab-pane>
                        <el-tab-pane v-if="publickData.isRise == 1" label="涨价后费率" name="rise">
                            <el-tabs v-model="riseActiveName">
                                <!-- Tab页 -->
                                <el-tab-pane
                                    v-for="(tabItem,tabIndex) in riseTabContent"
                                    :label="tabItem.title"
                                    :name="String(tabItem.settle_type)"
                                    :key="tabIndex"
                                >
                                    <template v-for="(titleItem,titleIndex) in tabItem.list">
                                        <!-- 小标题 -->
                                        <div :key="titleIndex">
                                            <div class="type_title">{{titleItem.title}}</div>
                                            <el-form-item
                                                v-for="(item,index) in titleItem.list"
                                                :label="item.title"
                                                :key="index"
                                            >
                                                <el-input
                                                    v-model="item.value"
                                                    size="medium"
                                                    :placeholder="isEdit ==1? item.sub_title : ''"
                                                    :disabled="level != 0 && canSet == false"
                                                ></el-input>
                                            </el-form-item>
                                            <el-divider></el-divider>
                                        </div>
                                    </template>
                                    <el-button
                                        :loading="btnLoading"
                                        @click="handleSubmit(tabItem.list,tabItem.settle_type,2)"
                                        type="primary"
                                        style="font-size:12px"
                                        :disabled="isEdit != 1"
                                        v-if="level == 0 || (isEdit == 1 && canSet == true)"
                                    >提 交</el-button>
                                </el-tab-pane>
                            </el-tabs>
                        </el-tab-pane>
                    </el-tabs>
                </el-form>
            </el-card>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: "UM_setUserRate",
    props: {
        isShowRate: {
            type: Boolean,
            default: false
        },
        publickData: {
            type: Object
        },
        canSet: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            baseOrRise: 'base', //基础费率or涨价后费率
            baseActiveName: '1', //基础费率 - Tab默认选中
            baseTabContent: [], //基础费率 -tab内容
            baseOldData: [], //基础费率 - 旧数据(对比使用)
            riseActiveName: '1',//涨价后费率 - Tab默认选中
            riseTabContent: [], //涨价后费率 -tab内容
            riseOldData: [], //涨价后费率 - 旧数据(对比使用)
            isEdit: 0, //是否可以编辑 1是 0否
            btnLoading: false,
            level: sessionStorage.getItem('level')
        }
    },
    mounted() {
        this.getBaseRate(); //基础费率
        if (this.publickData.isRise == 1) {
            this.getRiseRate(); //涨价后费率
        }
    },
    methods: {
        handleSubmit(val, settleType, rateType) {
            this.btnLoading = true;
            let { brandId, userId } = this.publickData;
            let BASE_URL;
            let changeKey;
            switch (rateType) { //1.基础 2.涨价
                case 1:
                    BASE_URL = 'user_rate/user_rate_update';
                    changeKey = this._.mapKeys(this.baseOldData, (value) => {
                        return value.settle_type;
                    });
                    break;
                case 2:
                    BASE_URL = 'user_rate/user_rate_rise_update';
                    changeKey = this._.mapKeys(this.riseOldData, (value) => {
                        return value.settle_type;
                    });
                    break;
                default:
                    break;
            }
            let dataSource = changeKey[settleType]; //T0 or T1

            let reqList = []; //请求的list
            let reqData = { //请求的数据
                brand_id: brandId,
                ally_user_id: userId
            };
            this._.forEach(val, (v, i) => {
                let child = [];
                let dataVal = dataSource.list[i];
                this._.forEach(v.list, (item, index) => {
                    let dataNew = dataVal.list[index];
                    if (item.value != '') {
                        if (dataNew.value != item.value) {
                            child.push(this._.pick(item, ['type', 'value']));
                        }
                    }
                })
                if (child.length != 0) {
                    let vtmp = this._.cloneDeep(v);
                    vtmp.list = child;
                    reqList.push(this._.omit(vtmp, ['title']));
                }
            });
            if (!this._.isEmpty(reqList)) {
                reqData.data = JSON.stringify(reqList);
            }

            this.$api.post(BASE_URL, reqData, res => {
                if (res.code == 0) {
                    this.$message.success(res.msg);
                    this.getBaseRate();
                    if (this.publickData.isRise == 1) {
                        this.getRiseRate();
                    }
                    this.btnLoading = false;
                } else {
                    this.$message({
                        type: 'error',
                        message: res.msg,
                        duration: 5000
                    })
                    this.btnLoading = false;
                }
            })
        },
        getBaseRate() { //获取基础费率
            let { brandId, userId } = this.publickData;
            this.$api.post('user_rate/user_rate_list', { brand_id: brandId, ally_user_id: userId }, res => {
                if (res.code == 0) {
                    let data = res.data;
                    this.baseTabContent = data.list;
                    this.isEdit = data.is_edit;
                    this.baseOldData = this._.cloneDeep(data.list);
                } else {
                    this.$message.error(res.msg);
                }
            })
        },
        getRiseRate() { //获取涨价后费率
            let { brandId, userId } = this.publickData;
            this.$api.post('user_rate/user_rate_rise_list', { brand_id: brandId, ally_user_id: userId }, res => {
                if (res.code == 0) {
                    let data = res.data;
                    this.riseTabContent = data.list;
                    this.riseOldData = this._.cloneDeep(data.list);
                } else {
                    this.$message.error(res.msg);
                }
            })
        },
        handleClose() {
            this.$emit('rateClose');
        }
    }
}
</script>

<style scoped lang="scss">
.setUserRate {
    ::v-deep .el-form-item__label {
        font-size: 12px;
        font-weight: 700;
    }
    ::v-deep .el-input__inner {
        width: 150px;
    }
    ::v-deep .el-dialog {
        height: 80%;
        .el-dialog__body {
            height: 82%;
            overflow: auto;
        }
    }
    .type_title {
        margin: 10px 0;
        font-size: 13px;
        font-weight: 700;
        border-left: 5px solid #40b8ff;
        padding: 0 0 0 10px;
    }
}
</style>
